export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
